import { Unit } from "./Enums";
import { ConversionService } from "../services/ConversionService";
export class UnitObject {

  public constructor(text: string, unit: Unit,private convServer: ConversionService) {
    this.DisplayText = text;
    this.Unit = unit;
  }

  Build(text: string, defaultUOM: string) {
    this.DisplayText = text;
    this.Unit = this.convServer.GetUnitFromString(defaultUOM);
  }

  public DisplayText: string;
  public Unit: Unit;
  
}
